import { useState, useEffect } from 'react';
import { getAuth, onAuthStateChanged } from 'firebase/auth';

const useUser = () => {
    const [user, setUser] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() =>{
        const unsubscribe = onAuthStateChanged(getAuth(), user => {
            console.log("******** calling the unsubscribe function **********")
            setUser(user);
            setIsLoading(false);
        });
        console.log("user: ",user, " isLoading: ", isLoading)
        console.log("Lets return unsubscribe from useUser.js")
        return unsubscribe;
    }, []);
    console.log("@@@@@@@@@@@@@@@ Lets return user and isLoading from useUser.js @@@@@@@@@@@@@@@")
    return { user, isLoading };
}

export default useUser;